// extracted by mini-css-extract-plugin
export default {"ProductCategoryCard":"ProductCategoryCard_ProductCategoryCard__KYDfF","small":"ProductCategoryCard_small__SfcF7"};